import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Box, Tooltip, Text} from '@chakra-ui/react'
import textStyles from '../../theme/foundations/textStyles'
import {HideOnDesktop, HideOnMobile} from '../responsive'

export const InfoIconTooltip = ({name, helpText, icon: Icon, iconProps}) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false)

    return (
        <Tooltip
            hasArrow
            id={`${name}-field-tooltip`}
            label={<Text>{helpText}</Text>}
            placement="top"
            isOpen={isTooltipOpen}
            {...textStyles['Regular Medium']}
            bg="stokkeCore.black"
        >
            <Box display="inline-block">
                <HideOnDesktop>
                    <Box
                        as="button"
                        onMouseLeave={() => {
                            setIsTooltipOpen(false)
                        }}
                        onClick={(event) => {
                            event.preventDefault()
                            setIsTooltipOpen((prev) => !prev)
                        }}
                        aria-expanded={isTooltipOpen}
                        {...(isTooltipOpen && {'aria-controls': `tooltip-${name}-field-tooltip`})}
                        aria-label={helpText}
                        data-testid={`${name}-mobile-tooltip-testid`}
                    >
                        <Icon variant="tooltip" {...iconProps} />
                    </Box>
                </HideOnDesktop>
                <HideOnMobile>
                    <Icon
                        variant="tooltip"
                        aria-label={helpText}
                        data-testid={`${name}-desktop-tooltip-testid`}
                        onMouseEnter={() => setIsTooltipOpen(true)}
                        onMouseLeave={() => setIsTooltipOpen(false)}
                        onClick={() => setIsTooltipOpen(true)}
                        {...iconProps}
                    />
                </HideOnMobile>
            </Box>
        </Tooltip>
    )
}

InfoIconTooltip.propTypes = {
    name: PropTypes.string,
    helpText: PropTypes.string,
    icon: PropTypes.node,
    iconProps: PropTypes.object
}
